<template>
    <!-- 草稿箱 -->
    <el-card v-loading="loading" class="container" shadow="never">
        <div slot="header">
            <div class="desciconLarge"></div>
            <span class="font18">草稿箱</span>
        </div>
        <div id="resetInput" class="search-box">
            <el-input clearable placeholder="请输入设备名称" v-model="subscribeDraftsListParams.equipmentName" prefix-icon="el-icon-search">
                <span slot="append" @click="getSubscribeDraftsList" style="cursor: pointer;">搜索</span>
            </el-input>
        </div>
        <div class="darfts-box">
            <div class="drafts" v-for="(item, index) in subscribeDraftsList" :key="item.id">
                <div class="drafts-title"> {{ item.equipmentName }} </div>
                <div class="drafts-content">
                    <img class="drafts-equipment" :src="item.pic" alt="">
                    <div class="drafts-info">
                        <div>
                            <div>添加时间：</div>
                            <div> {{ item.addDate }} </div>
                        </div>
                        <div class="button-box">
                            <el-button class="el-icon-delete" size="mini" type="danger" plain :loading="item.loading" @click="deleteSubscribeDrafts(item.id, index)">删除</el-button>
                            <el-button class="el-icon-edit" size="mini" type="success" plain :loading="item.loading" @click="toDetectionOrder(item)">继续编辑</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import { subscribeDraftsList, deleteSubscribeDrafts } from "@/api/request"

export default {
    data() {
        return {
            loading: false,
            //草稿箱查询参数
            subscribeDraftsListParams: {
				clientId: null,
				equipmentName: '',
			},
            subscribeDraftsList: [],//草稿箱列表
        }
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    created() {
        this.subscribeDraftsListParams.clientId = this.userInfo.clientId
        this.getSubscribeDraftsList()
    },
    methods: {
        //获取草稿箱列表
        async getSubscribeDraftsList() {
            this.loading = true
            const res = await subscribeDraftsList(this.subscribeDraftsListParams)
            res.rows.forEach(item => {
                item.pic = process.env.VUE_APP_FILE_API + item.fileList[0].url
                item.loading = false
            })
            this.subscribeDraftsList = res.rows
            this.loading = false
        },
        // 删除草稿
		deleteSubscribeDrafts(id, index) {
            this.$confirm('是否确认删除该草稿？', '温馨提示', {
                confirmButtonText: '确定',
                type: 'warning'
            }).then(async () => {
                this.subscribeDraftsList[index].loading = true
                await deleteSubscribeDrafts(id)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.subscribeDraftsList[index].loading = false
                this.getSubscribeDraftsList()
            })
		},
        // 继续编辑
        toDetectionOrder(item) {
            this.$router.push({
                path: "/appointPage",
                query: {
                    mode: 'draftsOrder',
                    id: item.equipmentId,
                    draftId: item.id,
                },
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    overflow: scroll;
    width: 100%;
    height: calc(100vh - 200px);
}
.search-box {
    margin-bottom: 15px;
}
.darfts-box {
    display: flex;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
    .drafts {
        width: calc(33% - 20px);
        min-width: 520px;
        border-radius: 5px;
        border: 1px solid #5CC300;
        .drafts-title {
            height: 50px;
            padding-left: 15px;
            font-size: 18px;
            line-height: 50px;
            background-color: #5CC30030;
        }      
        .drafts-content {
            display: flex;
            column-gap: 15px;
            padding: 15px;
            .drafts-equipment {
                width: 120px;
                height: 120px;
                border-radius: 5px;
                border: 1px solid #ccc;
            }
            .drafts-info {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 100%;
                height: 120px;
                font-size: 16px;
                .button-box {
                    display: flex;
                    justify-content: flex-end;
                    width: 100%;
                }
            }
        } 
    }
}
</style>